import { ActivitySpinnerSize, ActivitySpinnerWidget } from '@tableau/widgets';
import React from 'react';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { sanitize } from '~src/commonInfra/utils/Sanitize';
import { HiddenUserStyles } from '~src/spacesPlatform/components/spaceComponents/SpacesStyles';

import { setupUIBindingForReactFunctionalComponent } from '../common/UIBindingForReact';
import { ContentSuggestionViewModel } from '../viewModels/ContentSuggestionViewModel';
import { activeSectionItem, alignCenter, contentSuggestionSectionItem, contentSuggestionSectionItemContent, contentSuggestionSectionItemIcon, section, sectionItem, sectionItemAutoFitContent, sectionItemFixedContent, sectionItemHorizontalLayout, useColorForHighlight } from './OmniboxV2Styles';

export const ContentSuggestionTestId = 'ContentSuggestion';

export function ContentSuggestion(props: { viewModel: ContentSuggestionViewModel }): JSX.Element {
    const viewModel = props.viewModel;
    setupUIBindingForReactFunctionalComponent(viewModel);

    return (!viewModel.contentSuggestionItems || viewModel.contentSuggestionItems.length > 0) ? <div data-tb-test-id={ContentSuggestionTestId} className={[section, 'tb-quicklinks-section-divider', (viewModel.omniboxViewModel.shouldUseColorHighlight() ? useColorForHighlight : null)].join(' ')}>
        {
            viewModel.contentSuggestionItems ? viewModel.contentSuggestionItems.map((item, index) => {
                return <a id={item.getIdentifier()} key={index} href={item.url} role='option' aria-selected={item === viewModel.currentKeyboardNavigableItem}
                    onClick={(event) => { event.preventDefault(); event.stopPropagation(); viewModel.onItemClicked(item, index); }}
                    className={[sectionItem, sectionItemHorizontalLayout, contentSuggestionSectionItem, (item === viewModel.currentKeyboardNavigableItem ? activeSectionItem : '')].join(' ')}>
                    <div className={[sectionItemFixedContent, contentSuggestionSectionItemIcon].join(' ')}>
                        <img src={item.icon} alt='' />
                    </div>
                    <div className={[sectionItemAutoFitContent, contentSuggestionSectionItemContent].join(' ')}>
                        <div className={sectionItemHorizontalLayout}>
                            <div className={sectionItemAutoFitContent} style={CommonStyles.Layout.TextEllipsis} dangerouslySetInnerHTML={{
                                __html:
                                    sanitize(item.titleHtml)
                            }}>
                            </div>
                            <div className={sectionItemFixedContent}>
                                {item.supportingData}
                            </div>
                        </div>
                        <div>
                            <>
                                {
                                    item.extraIcon ?
                                        <>
                                            <span><img src={imgPath(item.extraIcon)} alt='' style={{ transform: 'translate(0, 2px)' }} /></span>
                                            <span>&nbsp;&bull;&nbsp;</span>
                                        </>
                                        : null
                                }
                            </>
                            <span>{item.contentType}</span>
                            <span>&nbsp;&bull;&nbsp;</span>
                            <span className={item.hiddenOwner ? HiddenUserStyles.HiddenUserClassName : ''} dangerouslySetInnerHTML={{
                                __html:
                                    sanitize(item.ownerHtml)
                            }}></span>
                        </div>
                    </div>
                </a>;
            })
                : <div className={ alignCenter } style={{ height: '134px' }}>
                    <ActivitySpinnerWidget
                        spinnerSize={ActivitySpinnerSize.Small}
                        testId={'omnibox-pending'}
                    />
                </div>
        }
    </div>
        : null;
}